import { useState } from 'react';

const AddEditGroupSettingPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddEditGroupSettingPopup, setShowAddEditGroupSettingPopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddEditGroupSettingPopup(!showAddEditGroupSettingPopup);
    };

    return (
      <Component
        showAddGroupSettingPopup={showAddEditGroupSettingPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddEditGroupSettingPopupHOC;
